/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DateTimeRangeSchema } from './DateTimeRangeSchema';
import {
    DateTimeRangeSchemaFromJSON,
    DateTimeRangeSchemaFromJSONTyped,
    DateTimeRangeSchemaToJSON,
} from './DateTimeRangeSchema';

/**
 * 
 * @export
 * @interface GridJobConfigSchemaOutput
 */
export interface GridJobConfigSchemaOutput {
    /**
     * Unique identifier for the record
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    id?: any | null;
    /**
     * Universal unique identifier for the record
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    uuid?: any | null;
    /**
     * Created at this point in time
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    createdAt?: any | null;
    /**
     * Created by this user
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    createdBy?: any | null;
    /**
     * Modified at this point in time
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    modifiedAt?: any | null;
    /**
     * Modified by this user
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    modifiedBy?: any | null;
    /**
     * Name of the job
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    jobName?: any | null;
    /**
     * Interval on hours for gps lost grid calculates
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    updateIntervalHours?: any | null;
    /**
     * Historical range for the job
     * @type {DateTimeRangeSchema}
     * @memberof GridJobConfigSchemaOutput
     */
    historicalRange?: DateTimeRangeSchema;
    /**
     * UUID of the shape
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    shapeUuid?: any | null;
    /**
     * Geojson data of the configuration
     * @type {{ [key: string]: any; }}
     * @memberof GridJobConfigSchemaOutput
     */
    geometryShape?: { [key: string]: any; } | null;
    /**
     * enable the job
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    enabled?: any | null;
    /**
     * grid cell size in meters
     * @type {any}
     * @memberof GridJobConfigSchemaOutput
     */
    gridCellSizeMeters?: any | null;
}

/**
 * Check if a given object implements the GridJobConfigSchemaOutput interface.
 */
export function instanceOfGridJobConfigSchemaOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GridJobConfigSchemaOutputFromJSON(json: any): GridJobConfigSchemaOutput {
    return GridJobConfigSchemaOutputFromJSONTyped(json, false);
}

export function GridJobConfigSchemaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GridJobConfigSchemaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : json['modified_at'],
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'jobName': !exists(json, 'job_name') ? undefined : json['job_name'],
        'updateIntervalHours': !exists(json, 'update_interval_hours') ? undefined : json['update_interval_hours'],
        'historicalRange': !exists(json, 'historical_range') ? undefined : DateTimeRangeSchemaFromJSON(json['historical_range']),
        'shapeUuid': !exists(json, 'shape_uuid') ? undefined : json['shape_uuid'],
        'geometryShape': !exists(json, 'geometry_shape') ? undefined : json['geometry_shape'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'gridCellSizeMeters': !exists(json, 'grid_cell_size_meters') ? undefined : json['grid_cell_size_meters'],
    };
}

export function GridJobConfigSchemaOutputToJSON(value?: GridJobConfigSchemaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt,
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt,
        'modified_by': value.modifiedBy,
        'job_name': value.jobName,
        'update_interval_hours': value.updateIntervalHours,
        'historical_range': DateTimeRangeSchemaToJSON(value.historicalRange),
        'shape_uuid': value.shapeUuid,
        'geometry_shape': value.geometryShape,
        'enabled': value.enabled,
        'grid_cell_size_meters': value.gridCellSizeMeters,
    };
}

